import { useViewModel } from './rewards.viewmodel'
import RewardsRoot from './rewards'

export default function Rewards() {
  const viewModel = useViewModel()
  return <RewardsRoot {...viewModel} />
}
